var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "169px",
    width: "169px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.308 492.308",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 18.707704
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.762,139.214H29.538C13.25,139.214,0,152.464,0,168.752v154.813c0,16.288,13.25,29.538,29.539,29.538h96.237 L313.087,489.56V2.748L125.762,139.214z M119.13,333.411H29.538c-5.428,0-9.846-4.418-9.846-9.846V168.752 c0-5.428,4.418-9.846,9.846-9.846h89.591V333.411z M293.394,450.849L138.822,338.243V154.065L293.394,41.459V450.849z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.692,85.099l-13.923,13.923c39.236,39.236,60.846,91.49,60.846,147.135c0,55.639-21.611,107.894-60.846,147.135 l13.923,13.923c42.957-42.957,66.615-100.154,66.615-161.058C492.308,185.252,468.649,128.055,425.692,85.099z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.014,139.786l-13.923,13.923c50.976,50.976,50.976,133.918,0,184.894l13.923,13.923 C428.668,293.873,428.668,198.44,370.014,139.786z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.762,139.214H29.538C13.25,139.214,0,152.464,0,168.752v154.813c0,16.288,13.25,29.538,29.539,29.538h96.237 L313.087,489.56V2.748L125.762,139.214z M119.13,333.411H29.538c-5.428,0-9.846-4.418-9.846-9.846V168.752 c0-5.428,4.418-9.846,9.846-9.846h89.591V333.411z M293.394,450.849L138.822,338.243V154.065L293.394,41.459V450.849z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.692,85.099l-13.923,13.923c39.236,39.236,60.846,91.49,60.846,147.135c0,55.639-21.611,107.894-60.846,147.135 l13.923,13.923c42.957-42.957,66.615-100.154,66.615-161.058C492.308,185.252,468.649,128.055,425.692,85.099z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.014,139.786l-13.923,13.923c50.976,50.976,50.976,133.918,0,184.894l13.923,13.923 C428.668,293.873,428.668,198.44,370.014,139.786z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerTwo);
export default __webpack_public_path__ + "static/media/speaker-two.2b888dd48961303e09511f35bd6dd765.svg";
export { ForwardRef as ReactComponent };